<template>
  <Layout navbarTransparent>
    <Header :image="current.procat_image" :header="current.procat_desc"  :header_eng="current.procat_desc_en"
    />

    <div class="my-4">
    </div>

    <template v-for="(data,idx) in list">
      <div :key="data.pl3_id">
        <comp-1 v-if="(idx + 1) % 2 != 0" :content="data.pl3_content" :image="data.pl3_image" :index="idx+1" />
        <comp-2 v-else :content="data.pl3_content" :index="idx+1" />
      </div>
    </template>


  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import Header from './header.vue'
import Comp1 from './components/layout3-comp1.vue'
import Comp2 from './components/layout2-comp2.vue'

import store from "@/store";

import {
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BTabs,
  BTab,
  BEmbed,
} from "bootstrap-vue";

export default {
  components: {
    Header, Comp1, Comp2,

    Layout,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTabs,
    BTab,
    BEmbed,
  }, 
  mounted(){
      this.getNextDatas()
  },
  computed: {
    currentLocale() {
      return this.$store.state.locales.CURRENT
    },
  },
  watch: {
    currentLocale(val) {
      this.getNextDatas();
    },
  },
  methods: {
    async getNextDatas(){
      this.current = await store.dispatch("product_categories/getDataList", {
        id: this.$route.params.id,
      });
      this.list = await store.dispatch("product_categories/getDataLayout3", {
        id: this.$route.params.id,
        langcode : this.currentLocale
      });
    }
  }, 
  data() {
    return {
      current: {}, list: []
    };
  },
};
</script>

<style>
.nav-tabs .nav-link.active {
  color: #ef6d22;
}
.nav-tabs .nav-link.active::after {
  background: #ef6d22 !important;
  height: 5px;
  border-radius: 3px;
}
</style>
